module.exports = __webpack_public_path__ + "img/2.437ad8ac.jpg";